import React from "react";
import ReactDOMServer from "react-dom/server";
import QRCode from "react-qr-code";
import jsPDF from "jspdf";
import canvg from "canvg";

import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import GetAppIcon from "@material-ui/icons/GetApp";

import { Button, translate } from "jazasoft";
import { rootUrl } from "../../App";

const useStyles = makeStyles({
  root: {
    margin: "2em"
  }
});

const Apk = () => {
  const classes = useStyles();

  const downloadApk = app => {
    const fileName = app.name.split(" ")[0] + ".apk";
    let link = document.createElement("a");
    link.href = app.url;
    link.download = fileName;
    link.click();
  };

  const onPrint = app => {
    const options = { orientation: "p", unit: "mm", format: [148, 105] };
    const doc = new jsPDF(options);

    //** Print Heading Text **//
    let startY = 15;

    // doc.addImage(logo, "PNG", 10, 8, 18, 18);
    doc.setFontSize(24);
    doc.setTextColor(29, 156, 217);
    doc.text("  WFX - Cutting Solutions", doc.internal.pageSize.getWidth() / 2, startY + 5, "center");
    // doc.text("WFX - MES", doc.internal.pageSize.getWidth() / 2, startY + 5, "center");
    doc.setTextColor(0, 0, 0);

    //** Print QR **//
    const width = 75;
    const height = 75;

    let svg = ReactDOMServer.renderToStaticMarkup(<QRCode value={`${app.url}`} level="H" />);
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");

    const v = canvg.fromString(context, svg);
    v.render();

    var imgData = canvas.toDataURL("image/png");

    const minDimension = width < height ? width : height;

    const imgWidth = minDimension - 20;
    const imgHeight = minDimension - 20;

    startY = startY + 28;
    doc.addImage(imgData, "PNG", (105 - imgWidth) / 2, startY, imgWidth, imgHeight);

    startY = startY + imgHeight;

    doc.setFontSize(12);
    doc.text(app.url, doc.internal.pageSize.getWidth() / 2, startY + 10, "center");

    doc.setFontSize(20);
    doc.text(app.name, doc.internal.pageSize.getWidth() / 2, startY + 35, "center");

    doc.save(`${app.name}.pdf`);
  };

  const appList = [{ name: "WFX - Feedback", url: `${rootUrl}/download/feedback` }];

  return (
    <div className={classes.root}>
      <Grid container spacing={4} justify="center">
        {appList.map(app => (
          <Grid item xs={12} sm={3}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button variant="contained" color="secondary" onClick={() => downloadApk(app)}>
                {app.name}
              </Button>
              <div style={{ display: "flex", alignSelf: "center", margin: "1em 0" }}>
                <QRCode id="qrCode" value={app.url} level={"H"} />
              </div>

              <Button variant="contained" color="primary" onClick={() => onPrint(app)}>
                <GetAppIcon />
                Download QR
              </Button>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default translate(Apk);
